import { render } from "./Expand.vue?vue&type=template&id=65d00774&scoped=true"
import script from "./Expand.vue?vue&type=script&lang=js"
export * from "./Expand.vue?vue&type=script&lang=js"

import "./Expand.vue?vue&type=style&index=0&id=65d00774&scoped=true&lang=less&rel=stylesheet%2Fless"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\partner\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d00774"]])

export default __exports__